import _ from 'lodash';

/* @ngInject */
export default function StatusPanelService($q, $sails, $log) {
  const service = this;

  let currentStatuses = {};

  service.getStatusForEquipment = getStatusForEquipment;
  service.getCurrentStatuses = getCurrentStatuses;
  service.updateCurrentStatusFromEvent = updateCurrentStatusFromEvent;
  service.deleteModel = deleteModel;

  function storeInitialStatusesForEquipment(statuses) {
    // add equipment statuses to currentStatuses holder by equipmentId
    currentStatuses[statuses.id].statuses = currentStatuses[statuses.id].statuses || {};

    _.forEach(statuses.data, (val, key) => {
      currentStatuses[statuses.id].statuses[key] =
          !_.isUndefined(val.value) && !_.isNull(val.value) ? val.value : val;
    });

  }

  function getStatusForEquipment(equipment) {
    // save the equipment info for each equipment on the panel
    if (!currentStatuses[equipment.id]) {
      currentStatuses[equipment.id] = {};
    }
    currentStatuses[equipment.id].equipment = equipment;
    return $sails.get(`/equipment/${equipment.id}/statuses/getAllStatuses/`)
      .then((success) => {
        storeInitialStatusesForEquipment({
          id: equipment.id,
          data: success.data
        });
        return equipment.id;
      })
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function getCurrentStatuses() {
    return currentStatuses;
  }

  function updateCurrentStatusFromEvent({ equipment, data }) {
    if (currentStatuses[equipment.id].statuses) {
      currentStatuses[equipment.id].statuses =
          _.reduce(currentStatuses[equipment.id].statuses, (memo, stat, key) => {
            stat = _.has(data, key) &&
              (!_.isUndefined(data[key].value) && !_.isNull(data[key].value)) ? data[key].value : data[key] ||
              stat;
            return _.assign(memo, { [key]: stat });
          }, {});
    }
  }

  function deleteModel() {
    currentStatuses = {};
  }
}
